import { useEffect, useRef } from "react";

// Lets Enter press a step's primary button. Ignored when something else has
// already claimed the key (the location autocomplete uses Enter to pick a
// suggestion), and on buttons and links, where Enter already activates them.
export default function useEnterToContinue(onContinue, enabled = true) {
  const latest = useRef(onContinue);
  latest.current = onContinue;

  useEffect(() => {
    if (!enabled) return undefined;

    function handleKeyDown(e) {
      if (e.key !== "Enter" || e.defaultPrevented || e.isComposing || e.repeat) return;
      if (e.target.closest?.("textarea, button, a")) return;
      e.preventDefault();
      latest.current();
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [enabled]);
}
